import {
  AddressSuggestionsProvider,
  kanosVersion,
  mountApp,
  setProblemTexts,
} from '@kanos/web-core';
import { EngagementPage } from './engagement';
import { IntakeDataPage } from './intake-data';
import { IdentifyDonePage, IdentifyPage } from './identify';
import { IntakeStart } from './intake-start';
import { InvitationPage } from './invitation';
import './styles.css';

// A client asks its firm, not the support of Kanos - the version still helps the firm ask on.
setProblemTexts({
  'internal.unexpected': `Etwas ist schiefgelaufen. Bitte versuchen Sie es noch einmal. Hilft das nicht, wenden Sie sich bitte an Ihre Kanzlei und nennen Sie die Version ${kanosVersion()}.`,
});

/** The pages of the portal so far, by their path (ADR-023, ADR-026, ADR-031). */
const PAGES: Record<string, () => React.JSX.Element> = {
  '/invitation': InvitationPage,
  '/intake': IntakeDataPage,
  '/engagement': EngagementPage,
  '/identify': IdentifyPage,
  '/identify/done': IdentifyDonePage,
};

const Page = PAGES[window.location.pathname] ?? IntakeStart;
// What a client states about itself suggests addresses while typed, from Kanos' own Photon: the
// fragment stays inside Kanos (ADR-073).
mountApp(
  <AddressSuggestionsProvider audience="portal">
    <Page />
  </AddressSuggestionsProvider>,
);
